// import { getSangjoQuotations } from "@/apis/sangjoQuotation";

import {
  Box,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
} from "@chakra-ui/react";
import {
  ColorIcon,
  colors,
  customEvent,
  getCdnImageSrc,
  GoiLogo,
  HStack,
  useResponsive,
  VStack,
  call,
  Image,
  HLine,
  icon,
  Spacing,
  EventTriggerAndTargetType,
  EventPathType,
  getPrimeUrl,
  GOI_PLATFORM_URL,
} from "goi_common";

// import { accountState, isLoggedInState } from "@/atoms/accountState";
import { useRouter } from "next/router";
import { Dispatch, SetStateAction, useMemo, useState } from "react";

import dayjs from "dayjs";
import HeaderButton from "./HeaderButton";
import { parseToPrimeUrl } from "../../utils/parseToPrimeUrl";
// import { MatchRecommenationQuotationType } from "@/containers/MatchContainer/type/MatchRecommendationType";

// interface FuneralGuideItemProps {
//   title: string;
//   image: string;
//   event: EventProps;
//   link: string;
//   onClose: () => void;
// }

interface MenuProps {
  isOpen: boolean;
  onClose: () => void;
}

// interface DrawerItemProps {
//   href: string;
//   icon?: ReactNode;
//   title: ReactNode;
//   event?: EventProps;
// }

interface ThirdMenuItemProps {
  title: string;
  key: string;
  to: string;
  tag?: string;
}
interface SecondMenuItemProps {
  iconName?: string;
  key: string;
  title: string;
  description?: string;
  to?: string;
  items?: ThirdMenuItemProps[];
}

interface FirstMenuItemProps {
  title: string;
  key: string;
  items: SecondMenuItemProps[];
}

function Menu({ isOpen, onClose }: MenuProps) {
  const router = useRouter();
  // const isLoggedIn = useRecoilValue(isLoggedInState);
  // const { data: quotationData } = useQuery(queryKeys.sangjoQuotation, () => getSangjoQuotations(), {
  //   enabled: isLoggedIn,
  // });
  // const quotationId: Array<MatchRecommenationQuotationType> = useMemo(() => {
  //   if (!quotationData || !isLoggedIn) {
  //     return undefined;
  //   } else if (quotationData.quotations[0]) {
  //     return quotationData.quotations[0].id;
  //   } else {
  //     return undefined;
  //   }
  // }, [quotationData, isLoggedIn]);
  const [currentFirstMenu, setCurrentFirstMenu] = useState("my");

  const { isBiggerThanMd } = useResponsive();

  const MENU_ITEMS: FirstMenuItemProps[] = useMemo(() => {
    return [
      {
        title: "상담/계약",
        key: "my",
        items: [
          {
            key: "quotation",
            title: "내 상담/견적 내역",
            to: `/match/request/`,
          },

          {
            key: "contract",
            title: "내 계약서 확인",
            to: getPrimeUrl("/contract-check/?utm_campaign=gnb_drawer"),
          },
          {
            key: "product",
            title: "상품 가입하기",
            to: "/product",
          },
        ],
      },
      {
        title: "상품 안내",
        key: "product",
        items: [
          {
            iconName: "thumbnail_24",
            key: "product_list",
            title: "전체 상품 보기",
            to: "/product/",
          },
          {
            iconName: "gift_24",
            key: "product_packages",
            title: "고이 패키지",
            description: "모든 패키지 가입일부터 즉시 이용 가능",
            items: [
              {
                title: "무빈소장 159",
                key: "simple_funeral",
                to: "/service/무빈소장",
              },

              {
                title: "가족장 279",
                key: "family_funeral",
                to: "/service/가족장",
              },

              {
                title: "일반장 379",
                key: "general_funeral",
                to: "/service/일반장",
              },
              {
                title: "프리미엄 패키지",
                key: "premium_funeral",
                to: "/promotion/service/가족장/premium-2025/",
              },
            ],
          },
          {
            iconName: "payment_24",
            key: "product_by_payment",
            title: "납입 방식별",
            items: [
              {
                title: "고이 프라임",
                key: "goi_prime_products",
                to: "/product#product_monthly",
                tag: "월 납입 상품",
              },

              {
                title: "고이 퍼스트",
                key: "goi_first_products",
                to: "/product#product_downpayment",
                tag: "계약금 납입 상품",
              },
            ],
          },
          {
            iconName: "write_24",
            key: "review",
            title: "이용 후기",
            to: "/review/",
          },
        ],
      },

      {
        title: "장례 절차",
        key: "guidebook",
        items: [
          {
            iconName: "thumbnail_24",
            key: "guidebook",
            title: "가이드북 전체",
            to: "/guidebook/",
          },
          {
            key: "guidebook_content",
            title: "장례 준비 처음부터 알아보기",
            items: [
              {
                title: "장례 준비의 시작",
                key: "funeral_prepare_1",
                to: "/funeral-prepare/1/",
              },

              {
                title: "장례식장 빈소 계약시 주의할 점",
                key: "guide_how_about_parlor_funeral",
                to: "/guide/how-about-parlor-funeral/",
              },

              {
                title: "상조 없이 장례를 치르려면?",
                key: "guide_about_parlor_funeral",
                to: "/guide/about-parlor-funeral/",
              },
              {
                title: "후불제 상조 알아보기",
                key: "funeral_prepare_2",
                to: "/funeral-prepare/2/",
              },
            ],
          },
          {
            iconName: "write_24",
            key: "review",
            title: "이용 후기",
            to: "/review/",
          },
        ],
      },
      {
        title: "읽을거리",
        key: "feed",
        items: [
          {
            key: "goi_feed",
            title: "고이 피드",
            to: getPrimeUrl("/content"),
          },
        ],
      },
      {
        title: "회사 소개",
        key: "company",
        items: [
          {
            key: "company_introduction",
            title: "고이장례연구소 소개",
            to: "/funeral-prepare/company-introduction/",
          },
          {
            key: "b2b",
            title: "기업 상조/제휴 문의",
            to: "https://partners.goifuneral.co.kr/?utm_campaign=platform/",
          },
        ],
      },
      {
        title: "고객 문의",
        key: "cs",

        items: [
          {
            key: "kakaotalk_chatting",
            title: "카카오톡 채팅 문의",
            to: "http://pf.kakao.com/_xgFDaK/chat",
          },
          {
            key: "email_cs",
            title: "이메일",
            to: "mailto:contact@goifuneral.co.kr",
          },
        ],
      },
    ];
  }, []);

  const currentMenuItems = useMemo(() => {
    return MENU_ITEMS.find((item) => item.key === currentFirstMenu)?.items;
  }, [currentFirstMenu]);
  // const account = useRecoilValueLoadable(accountState);
  const login = () => {
    router.push(GOI_PLATFORM_URL + `/login/`).finally(() => {
      onClose();
    });
  };
  // const { data } = useQuery(["funeral_reviews"], () => {
  //   return Axios.get("/sangjo_reviews/");
  // });

  // const viewReviewData = data?.data.results?.filter((item: any) => {
  //   return item.score >= 4;
  // })[0];

  return (
    <Drawer isOpen={isOpen} placement="right" onClose={onClose}>
      <DrawerOverlay bg="rgba(0, 0, 0, 0.5)" />
      <DrawerContent
        width="100%!important"
        maxWidth={isBiggerThanMd ? "360px" : "100%"}
      >
        <DrawerHeader
          flexDirection="column"
          display="flex"
          alignItems="flex-start"
          justifyContent="center"
          p="13px 16px 13px 20px"
        >
          <HStack
            justifyContent="space-between"
            alignItems="center"
            width="100%"
            gap="16px"
          >
            <HStack
              alignItems="center"
              gap={24}
              width="100%"
              justifyContent="space-between"
            >
              <HStack alignItems="center" gap={8}>
                <GoiLogo size={30} color={colors.goiBlack} />
              </HStack>
              <HeaderButton
                path="gnb"
                type="RED"
                onClick={() => {
                  call("1666-9784");
                  // router.push("/funeral-prepare/1/");
                }}
                eventTrigger="hbg_srvc_rcmms-uv_funeral_prepare_1"
              >
                24시간 고객센터
              </HeaderButton>
            </HStack>
            <Box
              onClick={onClose}
              width="24px"
              style={{
                width: "24px",
                height: "24px",
                padding: "0px",
                margin: "0",
                background: "none",
              }}
            >
              <ColorIcon name="header-close" size={24} color={colors.gray900} />
            </Box>
          </HStack>
        </DrawerHeader>
        {/* <DrawerSpacer /> */}

        <DrawerBody p="0">
          <VStack gap="24px" padding="32px 20px">
            <Box
              borderRadius="6px"
              // border={`1px solid ${colors.gray400}`}
              className="body3_r"
              display="flex"
              flexDirection="row"
              alignItems="center"
              backgroundColor={colors.gray50}
            >
              {/* {account.state === "hasValue" && !account.contents ? ( */}
              <HStack
                padding="12px 16px"
                width="100%"
                justifyContent="space-between"
                alignItems="center"
                onClick={login}
                color={colors.gray700}
              >
                <span
                  className="body_16_r"
                  css={{
                    backgroundColor: colors.gray50,
                  }}
                >
                  로그인 / 회원가입
                </span>{" "}
                <ColorIcon
                  name="chevron_right_24"
                  size={24}
                  color={colors.gray700}
                />
              </HStack>
              {/* ) : (
                <HStack
                  padding="10px 16px"
                  gap={6}
                  alignItems="center"
                  justifyContent="space-between"
                  width="100%"
                  onClick={() => {
                    router.push("/my/");
                    customEvent({
                      newGtm: { path: "gnb", trigger_and_target: "mypage-uv_my" },
                    });
                    onClose();
                  }}
                  color={colors.gray700}
                >
                  <HStack alignItems="center" gap="4px">
                    <span className="body_18_m gray900">{account.contents.nickname + "님"}</span>
                    <HStack alignItems="center" gap="4px">
                      <span className="body_16_r gray600">| 견적, 계약 확인</span>{" "}
                    </HStack>
                  </HStack>
                  <ColorIcon name="chevron_right_24" size={24} color={colors.gray700} />
                </HStack>
              )} */}
            </Box>
            <HStack width="100%">
              <MainIconMenu
                iconSrc={getCdnImageSrc("platform/home/coin.png")}
                title="100원 상조"
                onClick={() => {
                  router.push("/?utm_campaign=platform_gnb_drawer");
                  customEvent({
                    newGtm: { path: "gdrwr", trigger_and_target: "main-prime" },
                  });
                  onClose();
                }}
              />

              <MainIconMenu
                iconSrc={getCdnImageSrc("platform/home/estimate_calculate.png")}
                title="장례 견적"
                onClick={() => {
                  router.push(parseToPrimeUrl("/match/request"));
                  customEvent({
                    newGtm: {
                      path: "gdrwr",
                      trigger_and_target: "main-match_request",
                    },
                  });

                  onClose();
                }}
              />
              <MainIconMenu
                iconSrc={getCdnImageSrc("platform/home/write.png")}
                title="실제 후기"
                onClick={() => {
                  router.push(parseToPrimeUrl("/review"));
                  customEvent({
                    newGtm: {
                      path: "gdrwr",
                      trigger_and_target: "main-review",
                    },
                  });
                  onClose();
                }}
              />
              <MainIconMenu
                iconSrc={getCdnImageSrc("platform/home/headset.png")}
                title="임종 접수"
                onClick={() => {
                  call("1666-9784");
                  customEvent({
                    newGtm: { path: "gdrwr", trigger_and_target: "main-call" },
                  });
                }}
              />
            </HStack>
          </VStack>
          <HLine height="1px" color={colors.gray100} />
          <HStack background={colors.gray50} height="calc(100vh - 270px)">
            <LeftMenus
              menuItems={MENU_ITEMS}
              currentFirstMenu={currentFirstMenu}
              setCurrentFirstMenu={setCurrentFirstMenu}
            />
            {currentMenuItems && (
              <RightMenus items={currentMenuItems} onClose={onClose} />
            )}
          </HStack>
          {/* <VStack padding="0 24px 18px 0">
            <DrawerItem
              href="/service/"
              icon={
                <Box margin="0 0 0 4px">
                  <ColorIcon name="drawer_goi_icon" size={32} color={""} />
                </Box>
              }
              title={
                <HStack gap="6px" alignItems="center">
                  <Box className="body_16_r">고이상조 서비스 전체 보기</Box>
                  <Badge
                    className="caption_11_sb"
                    color={colors.orange700}
                    backgroundColor={colors.orange150}
                    css={{
                      borderRadius: "11px",
                      padding: "4px 6px",
                    }}
                  >
                    사전상담 할인가
                  </Badge>
                </HStack>
              }
              event={{
                newGtm: { path: "gnb", trigger_and_target: "drawer-service" },
              }}
            />

            <DrawerItem
              href="/match/request/"
              icon={
                <Box margin="0 0 0 4px">
                  <ColorIcon name="icon-document-search" size={32} color={""} />
                </Box>
              }
              title={<Box className="body_16_r">장례 전체 비용 견적, 맞춤형 혜택 알아보기</Box>}
              event={{
                newGtm: { path: "gnb", trigger_and_target: "drawer-mtch_rqst" },
              }}
            />

            <DrawerItem
              href="/guidebook/"
              icon={
                <Box margin="0 0 0 4px">
                  <ColorIcon name="book_has_bookmark" size={32} color="" />
                </Box>
              }
              title={<Box className="body_16_r">장례의 모든 정보, 무료 온라인 가이드북</Box>}
              event={{
                newGtm: { path: "gnb", trigger_and_target: "drawer-guidebook" },
              }}
            />
          </VStack> */}

          {/* <DrawerSpacer /> */}

          {/* <MenuReviewItem onClose={onClose} viewReviewData={viewReviewData} /> */}

          {/* <DrawerSpacer />

          <VStack overflow="hidden" padding="24px">
            <Box className="subtitle_18_sb">장례 준비, 제일 궁금한 점들을 모았어요</Box>

            <Box overflow="scroll">
              <HStack overflow="scroll" width="max-content" padding="16px 0px" gap="16px">
                {MENU_FUNERAL_GUIDE_ITEMS.map((item) => (
                  <MenuFuneralGuideItem key={item.link} {...item} onClose={onClose} />
                ))}
              </HStack>
            </Box>
          </VStack>
          <DrawerSpacer /> */}
        </DrawerBody>

        {/* <DrawerFooter padding="16px 24px">
          <VStack
            width="100%"
            height="60px"
            alignItems="center"
            justifyContent="center"
            background={colors.orange650}
            borderRadius="5px"
            color={colors.white}
            css={{
              cursor: "pointer",
            }}
            onClick={() => {
              call("1666-9784", true);
            }}
          >
            <HStack color={colors.white} alignItems="center" gap="6px">
              <ColorIcon color={colors.white} name="icon-call-mono" size={20} />
              <Box className="button_16_sb white">24시간 상담 / 임종 접수</Box>
            </HStack>
          </VStack>
        </DrawerFooter> */}
      </DrawerContent>
    </Drawer>
  );
}

// const DrawerSpacer = styled.div`
//   width: 100%;
//   height: 6px;
//   background: var(--gray50);
// `;

// const DrawerItemRoot = styled(NextLink)`
//   margin-left: 0;
//   display: flex;
//   align-items: center;
//   width: 100%;
//   height: 56px;
//   padding-left: 20px;
//   = :active {
//     background: var(--gray50);
//   }

//   .body3_m {
//     padding-left: 12px;
//   }
// `;

export const formatReviewDate = (date: Date) => {
  const created = dayjs(date);
  const now = dayjs();

  const diffDays = now.diff(created, "day");
  const diffHours = now.diff(created, "hour");
  const diffMinutes = now.diff(created, "minute");

  if (diffDays < 1) {
    if (diffHours < 1) {
      return { text: `${diffMinutes}분 전`, color: colors.orange650 };
    } else {
      return { text: `${diffHours}시간 전`, color: colors.orange650 };
    }
  } else if (diffDays < 4) {
    return { text: `${diffDays}일 전`, color: colors.orange650 };
  } else {
    return { text: created.format("YYYY.MM.DD"), color: colors.gray500 };
  }
};

export default Menu;

// export const MenuReviewItem = ({
//   onClose,
//   viewReviewData,
// }: {
//   onClose: () => void;
//   viewReviewData: any;
// }) => {
//   const router = useRouter();

//   return (
//     <VStack padding="24px" background={colors.white}>
//       <HStack justifyContent="space-between" alignItems="center">
//         <Box className="subtitle_18_sb gray900">
//           고이상조 이용 후기
//           {/* <sup className="subtitle_12_b orange650">NEW</sup> */}
//         </Box>
//         <HStack
//           gap={6}
//           css={{
//             cursor: "pointer",
//           }}
//           alignItems="center"
//           onClick={() => {
//             router.push("/review/");
//             customEvent({
//               newGtm: {
//                 path: "gnb",
//                 trigger_and_target: "review-uv_review",
//               },
//             });

//             onClose();
//           }}
//         >
//           <span className="body_14_r gray600">전체보기</span>
//           <ColorIcon name="arrow_forward_rounded" color={colors.gray600} size={13} />
//         </HStack>
//       </HStack>

//       <HStack gap={12} width="100%" margin="12px 0 0 0">
//         {viewReviewData && (
//           <VStack
//             padding="16px 20px"
//             background={colors.gray50}
//             borderRadius="6px"
//             width="100%"
//             gap="10px"
//             css={{
//               cursor: "pointer",
//             }}
//             onClick={() => {
//               customEvent({
//                 newGtm: {
//                   path: "gnb",
//                   trigger_and_target: "recent_review-uv_review_detail",
//                   text: String(viewReviewData.id),
//                 },
//                 triggerHackle: true,
//               });
//               router.push(`/review/${viewReviewData.id}/`);
//               onClose();
//             }}
//           >
//             <HStack alignItems="center" justifyContent="space-between">
//               <HStack alignItems="center" gap="4px">
//                 <Box>
//                   <ColorIcon name="rating_star" size={14} color={colors.orange650} />
//                 </Box>
//                 <Box className="subtitle_14_b gray900">{viewReviewData.score}.0</Box>

//                 <Box className="caption_11_r gray500">
//                   | {`${viewReviewData.user.age_and_gender} ` || ""}
//                   {viewReviewData.user.nickname}님
//                 </Box>
//               </HStack>
//               <Box
//                 className={"caption_11_r"}
//                 color={formatReviewDate(viewReviewData.created_at).color}
//               >
//                 {formatReviewDate(viewReviewData.created_at).text}
//               </Box>
//             </HStack>

//             <VStack position="relative" gap="4px">
//               <Box
//                 className="body_14_r gray900"
//                 css={{
//                   display: "-webkit-box",
//                   WebkitLineClamp: 3,
//                   WebkitBoxOrient: "vertical",
//                   overflow: "hidden",
//                   maxWidth: "100%",
//                 }}
//               >
//                 {viewReviewData.good}
//               </Box>
//               {viewReviewData.good.length > 80 && (
//                 <Box
//                   className="caption_12_r gray500"
//                   cursor="pointer"
//                   onClick={() => {
//                     customEvent({
//                       newGtm: {
//                         path: "gnb",
//                         trigger_and_target: "recent_review-uv_review_detail",
//                         text: String(viewReviewData.id),
//                       },
//                       triggerHackle: true,
//                     });
//                     router.push(`/review/${viewReviewData.id}/`);
//                     onClose();
//                   }}
//                 >
//                   더보기
//                 </Box>
//               )}
//             </VStack>
//           </VStack>
//         )}
//       </HStack>
//     </VStack>
//   );
// };

const MainIconMenu = ({
  iconSrc,
  title,
  onClick,
}: {
  iconSrc: string;
  title: string;
  onClick: () => void;
}) => {
  return (
    <VStack gap="6px" alignItems="center" width="100%" onClick={onClick}>
      <Image src={iconSrc} width={48} />
      <Box className="body_14_r gray900" width="100%" textAlign="center">
        {title}
      </Box>
    </VStack>
  );
};

const LeftMenus = ({
  menuItems,
  currentFirstMenu,
  setCurrentFirstMenu,
}: {
  menuItems: FirstMenuItemProps[];
  currentFirstMenu: string;
  setCurrentFirstMenu: Dispatch<SetStateAction<string>>;
}) => {
  return (
    <VStack width="116px">
      {menuItems.map((item) => {
        return (
          <Box
            padding="16px 20px"
            onClick={() => {
              customEvent({
                newGtm: {
                  path: "gdrwr",
                  trigger_and_target:
                    `1_${item.key}` as EventTriggerAndTargetType[EventPathType],
                },
              });
              setCurrentFirstMenu(item.key);
            }}
            key={item.key}
            className={`${
              currentFirstMenu === item.key
                ? "subtitle_16_sb gray900"
                : "body_16_r gray700"
            }`}
            background={
              currentFirstMenu === item.key ? colors.white : colors.gray50
            }
          >
            {item.title}
          </Box>
        );
      })}
    </VStack>
  );
};

const RightMenus = ({
  items,
  onClose,
}: {
  items: SecondMenuItemProps[];
  onClose: () => void;
}) => {
  const router = useRouter();
  return (
    <VStack padding="16px" background="white" flexGrow={1} overflow="scroll">
      {items.map((childItem, index) => {
        return (
          <VStack
            key={childItem.key}
            onClick={() => {
              if (childItem.to) {
                customEvent({
                  newGtm: {
                    path: "gdrwr",
                    trigger_and_target:
                      `2_${childItem.key}` as EventTriggerAndTargetType[EventPathType],
                  },
                });
                router.push(parseToPrimeUrl(childItem.to)).finally(() => {
                  onClose();
                });
              }
            }}
          >
            <SecondMenuItem item={childItem} onClose={onClose} />
            {index !== items.length - 1 && (
              <>
                <Spacing gap={12} />
                <HLine height="1px" color={colors.gray100} />
                <Spacing gap={12} />
              </>
            )}
          </VStack>
        );
      })}
    </VStack>
  );
};

const SecondMenuItem = ({
  item,
  onClose,
}: {
  item: SecondMenuItemProps;
  onClose: () => void;
}) => {
  const router = useRouter();
  return (
    <VStack>
      <HStack padding="12px 0" gap="6px">
        {item.iconName && (
          <ColorIcon
            name={item.iconName as keyof typeof icon}
            color=""
            size={24}
          />
        )}
        <HStack justifyContent="space-between" width="100%">
          <Box className="subtitle_16_sb gray900">{item.title}</Box>
          {item.to && (
            <ColorIcon
              name="chevron_right_24"
              size={24}
              color={colors.gray700}
            />
          )}
          {item.items && (
            <ColorIcon name="chevron_up_24" size={24} color={colors.gray700} />
          )}
        </HStack>
      </HStack>
      {item.items && (
        <VStack margin="8px 0 0 0">
          {item.items?.map((childItem) => {
            return (
              <HStack
                key={childItem.key}
                gap="6px"
                padding="12px 0"
                onClick={() => {
                  if (childItem.to) {
                    customEvent({
                      newGtm: {
                        path: "gdrwr",
                        trigger_and_target:
                          `3_${item.key}_${childItem.key}` as EventTriggerAndTargetType[EventPathType],
                      },
                    });

                    router.push(parseToPrimeUrl(childItem.to)).finally(() => {
                      onClose();
                    });
                  }
                }}
                alignItems="center"
              >
                <Box className="body_16_r gray700">{childItem.title}</Box>
                {childItem.tag && (
                  <Box
                    padding="2px 8px"
                    borderRadius="13px"
                    className="caption_11_m orange700"
                    background={colors.orange150}
                  >
                    {childItem.tag}
                  </Box>
                )}
              </HStack>
            );
          })}
        </VStack>
      )}
    </VStack>
  );
};
